define('lq/constants',[
    'lq/enum'
], function (Enum) {
    'use strict';
    
    var getIndex = function () {
        return this.enum.keys().indexOf(this.name);
    };

    var constants = {
        licquidDateFormat: 'S', // 2000-08-17T16:32:32
        valueTypes: {
            uniqueIdentifier: 'System.Guid',
            dateTime: 'System.DateTime',
            decimal: 'System.Decimal',
            integer: 'System.Int32',
            string: 'System.String',
            boolean: 'System.Boolean',
            document: 'LicquidDocumentVersionDetail'
        },
        // since we use getIndex to get the codes here, order does matter
        layoutTypes: new Enum("LayoutTypes", ['Desktop', 'TabletPortrait', 'TabletLandscape', 'PhonePortrait', 'PhoneLandscape'], { getIndex: getIndex }),
        deviceTypes: new Enum("DeviceTypes", ['Desktop', 'Tablet', 'Phone'], { getIndex: getIndex }),
        orientations: new Enum("Orientations", ['Portrait', 'Landscape'], { getIndex: getIndex }),
        mappingTypes: new Enum("Mapping types", ['Parameter', 'DataSource', 'ViewModel', 'FixedValue','QueryString','NullValue'])
    };

    constants.valueTypeLabels = {};
    constants.valueTypeLabels[constants.valueTypes.string] = 'String',
    constants.valueTypeLabels[constants.valueTypes.integer] = 'Natural Number',
    constants.valueTypeLabels[constants.valueTypes.decimal] = 'Decimal',
    constants.valueTypeLabels[constants.valueTypes.dateTime] = 'DateTime',
    constants.valueTypeLabels[constants.valueTypes.boolean] = 'Boolean',
    constants.valueTypeLabels[constants.valueTypes.uniqueIdentifier] = 'Unique identifier'

    constants.valueTypeSelection = [
        { key: constants.valueTypes.string, value: constants.valueTypeLabels[constants.valueTypes.string] },
        { key: constants.valueTypes.integer, value: constants.valueTypeLabels[constants.valueTypes.integer] },
        { key: constants.valueTypes.decimal, value: constants.valueTypeLabels[constants.valueTypes.decimal] },
        { key: constants.valueTypes.dateTime, value: constants.valueTypeLabels[constants.valueTypes.dateTime] },
        { key: constants.valueTypes.boolean, value: constants.valueTypeLabels[constants.valueTypes.boolean] },
        { key: constants.valueTypes.uniqueIdentifier, value: constants.valueTypeLabels[constants.valueTypes.uniqueIdentifier] }
    ];

    if (Object.freeze) {
        Object.freeze(constants.valueTypes);
        Object.freeze(constants.valueTypeLabels);
    	Object.freeze(constants);
    }

    return constants;
});
